import { pipe } from "fp-ts/lib/function";
import { getTaxCodeDetailsForGewest } from "../aangiftecodesForm/taxCodesApi";
import { Gewest } from "../personaliaForm/citiesApi";
import { array, either } from "fp-ts";

interface Props {
  company: string;
  locale: string;
  values: Record<string, unknown>;
  insuranceLink: string;
  pensionLink: string;
}

const isAllowedField = (key: string) => ["address", "name", "trate", "postalcode", "town"].includes(key);
export const isRubriekKey = (key: string) => /^c[1-4][0-9]{3}$/.test(key);

const sanitizeValue = (gewest: Gewest) => (key: string, value: unknown) => {
  if (typeof value !== "number") return value;

  return pipe(
    key.substr(1),
    getTaxCodeDetailsForGewest(gewest),
    either.fold(
      () => value, // note: niet alle codes zitten in aangiftemodel (zie SPB-1289) => behoudt value as is for now
      (taxCode) => {
        switch (taxCode.type) {
          case "":
          case "pct":
            return value.toFixed(2);
          case "num":
            return value.toFixed(0);
          default:
            return value;
        }
      }
    )
  );
};

const hasValue = (value: unknown) => value !== undefined && value !== null && value !== "";

const sanitizeValues = (values: Record<string, unknown>) => {
  const sanitizeValueForGewest = sanitizeValue(values.gewest as Gewest);
  return pipe(
    Object.entries(values),
    array.filter(([key, value]) => hasValue(value) && (isAllowedField(key) || isRubriekKey(key))),
    array.reduce({} as Record<string, unknown>, (acc, [key, value]) => {
      acc[key] = sanitizeValueForGewest(key, value);
      return acc;
    })
  );
};

export const fetchResult = async ({ company, locale, values, pensionLink, insuranceLink }: Props) => {
  const url = `${process.env.REACT_APP_API_URL}/web/getresult.php?p=${company}${locale}`;
  const form = new URLSearchParams();
  form.append("savedCodes", JSON.stringify(sanitizeValues(values)));

  const response = await fetch(url, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    method: "POST",
    body: form,
  });

  const responseText = await response.text();
  return responseText
    .replace(/\{\{insuranceURL\}\}/g, insuranceLink)
    .replace(/\{\{pensionURL\}\}/g, pensionLink)
    .split("§") as [string, string];
};
